
<template>
  <div>
    <div class="app-content main-content">
      <div class="side-app">
        <div class="page-header">
          <div class="page-leftheader">
            <h4 class="page-title mb-5 text-primary">法人向け求人アップロード</h4>
          </div>
          <div class="page-rightheader">
          </div>
        </div>
      </div>

      <div class="container d-flex justify-content-center align-items-center">
        <div class="drop_area" @dragenter="dragEnter" @dragleave="dragLeave" @dragover.prevent @drop.prevent="dropFile"
            :class="{ enter: isEnter }">

            <p class="area-help"><img class="file_icon" src="../assets/images/import.png"><br/>こちらにファイルをドラッグ＆ドロップしてインポートします<br/>
            <label class="from_io" for="file_upload">
                パソコン/USBから追加する
                <input id="file_upload" type="file" accept="application/pdf" class="file" title @change="dropFile" @click="clearFileInput" multiple/>
            </label></p>
        </div>
      </div>

    </div>
    <CModal
      title="求人票インポート"
      color="info"
      :show.sync="importModal"
    >
      <CRow class="form-box">
        <CCol sm="12">
          <label class="record-label pt-3">求人票インポート情報</label>
        </CCol>

        <CCol sm="12">
          <label class="record-label pt-3">法人名</label>

          <div class="input-group mb-2 w-100">
            <input
              v-model.trim="companyFilter"
              type="text"
              class="form-control"
              placeholder="法人名で部分一致 / IDで一致"
            />
            <button class="btn btn-outline-secondary" type="button" @click="companyFilter=''">
              クリア
            </button>
          </div>
          <select
            class="form-control"
            v-model.number="record.company_id"
            :class="{ 'hasError': $v.record.company_id.$error }"
          >
            <option value="" disabled>法人名を選択してください</option>
            <option v-for="c in filteredCompanies" :key="c.value" :value="c.value">
              {{ c.label }}
            </option>
          </select>
        </CCol>

        <CCol sm="12">
          <label class="record-label pt-3">ハリケンナビURL</label>
          <CInput
            placeholder="ハリケンナビURLを入力してください"
            v-model="importForm.harikennabi_url"
          />
        </CCol>
      </CRow>

      <template #footer>
        <CButton size="sm" @click="closeImportModal">キャンセル</CButton>
        <CButton
          size="sm"
          color="info"
          :disabled="!canSubmitImport"
          @click="confirmImport"
        >
          インポート
        </CButton>
      </template>
    </CModal>

  </div>
</template>


<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import { required } from "vuelidate/lib/validators";
import { mapGetters } from 'vuex';
// 必要ならトークンは localStorage 等から取る
// import { projectAuth } from '@/firebase/config'

export default {
  name: 'JobImport',
  data() {
    return {
      companyFilter: "",
      isEnter: false,
      files: [],
      record: { company_id: '' },
      companyTypes: [],
      importModal: false,
      importTouched: false,
      importForm: {
        harikennabi_url: ''
      },
      jobTypeOptions: [
        { label: '公開求人', value: 'public' },
        { label: '指定校求人', value: 'designated' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    }),
    canSubmitImport() {
      return !!this.record.company_id
    },
    filteredCompanies() {
      const q = this.companyFilter.toLowerCase();

      if (!q) return this.companyTypes;

      const idMatch = q.startsWith("id:") ? Number(q.replace("id:", "").trim()) : null;
      if (idMatch !== null && !Number.isNaN(idMatch)) {
        return this.companyTypes.filter(c => Number(c.value) === idMatch);
      }

      const asNum = Number(q);
      const isPureNumber = q.replace(/\s+/g, "") !== "" && !Number.isNaN(asNum);

      if (isPureNumber) {
        const idHit = this.companyTypes.filter(c => Number(c.value) === asNum);
        if (idHit.length) return idHit;
        return this.companyTypes.filter(c => (c.label || "").toLowerCase().includes(q));
      }

      return this.companyTypes.filter(c => (c.label || "").toLowerCase().includes(q));
    }
  },
  validations: {
    record: {
      company_id: {required}
    },
  },
  methods: {
    dragEnter() { this.isEnter = true },
    dragLeave() { this.isEnter = false },
    dragOver() {},

    async dropFile (ev) {
      const files = ev?.target?.files || ev?.dataTransfer?.files || []
      if (!files || files.length === 0) return
      this.files = files

      const allPdf = Array.from(files).every(f =>
        /\.pdf$/i.test(f.name) && (!f.type || f.type === 'application/pdf' || f.type.startsWith('application/pdf'))
      )
      if (!allPdf) {
        alert('PDFファイルのみアップロード可能です')
        this.files = []
        return
      }

      // 枚数チェック
      if (files.length > 10) {
        alert('10 個のファイルのみをインポートする')
        this.files = []
        return
      }

      for (const f of files) {
        if (f.size > 10 * 1024 * 1024) {
          alert('ファイルが大きすぎます。10MB以下にしてください')
          this.files = []
          return
        }
      }
      this.openImportModal()
    },

    openImportModal() {
      this.importTouched = false
      this.importModal = true
    },
    clearFileInput (e) {
      if (e && e.target) e.target.value = null
    },
    closeImportModal () {
      this.importModal = false
      this.isEnter = false
      this.files = []
      this.$nextTick(() => {
        if (this.$refs.fileInput) this.$refs.fileInput.value = null
      })
    },
    confirmImport () {
      this.importTouched = true
      this.$v?.record?.company_id?.$touch?.()
      if (!this.canSubmitImport) return
      this.importModal = false
      this.uploadFiles().finally(() => {
        this.files = []
        this.$nextTick(() => {
          if (this.$refs.fileInput) this.$refs.fileInput.value = null
        })
      })
    },
    uploadFiles() {
      return Promise.all([].map.call(this.files, (file) => {
        return new Promise((resolve) => {
          const reader = new FileReader()
          reader.onload = () => resolve(reader.result)
          reader.readAsDataURL(file)
        })
      })).then((results) => {
        Swal.fire({
          title: 'インポート中...',
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => Swal.showLoading(),
        })

        return axios.post(
          process.env.VUE_APP_API_ENDPOINT + '/api/mng/jobs',
          {
            pdf: results,
            harikennabi_url: this.importForm.harikennabi_url || null,
            company_id: Number(this.record.company_id),
          },
          { headers: { Authorization: 'Bearer ' + this.idToken } }
        ).then(() => {
          Swal.close()
          return Swal.fire({
            title: 'インポート開始しました',
            icon: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK',
            allowOutsideClick: false
          }).then((r) => { if (r.isConfirmed) this.$router.push({ name: 'tasks' }) })
        }).catch((err) => {
          Swal.close()
          const res = err.response
          let msg = 'エラーが発生しました。'
          if (res?.data) {
            const d = res.data
            if (typeof d.errors === 'string') {
              msg = d.errors
            } else if (d.errors && typeof d.errors === 'object') {
              msg = Object.entries(d.errors)
                .map(([k, v]) => `${k}: ${[].concat(v).join(', ')}`)
                .join('\n')
            } else if (d.message) {
              msg = d.message
            }
          } else if (err.message) {
            msg = err.message
          }
          return Swal.fire({
            title: 'インポートに失敗しました',
            text: msg,
            icon: 'error',
            confirmButtonColor: '#3085d6',
          })
        }).finally(() => {
          this.isEnter = false
        })
      })
    },
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/companies_all", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        response.data.forEach(row =>{
          this.companyTypes.push({
            value: Number(row.id),
            label: `${row.id} : ${row.name}`
          })
        })
      }).catch(error => {
        this.errorNotify(error.response)
      })
  },
}
</script>
<style style="scss" scoped>
  h1 {
    border-bottom: 1px solid #F1F1F1;

  }
  .drop_area {
    color: gray;
    font-weight: bold;
    font-size: 1.2em;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
    height: 500px;
    border-radius: 15px;

    border: 1px dashed gray;
    border-radius: 15px;
    border-width: thick;
  }

  .enter {
      border: 10px dotted powderblue;
  }

  .delete-mark {
      position: absolute;
      top: -14px;
      right: -10px;
      font-size: 20px;
  }
  .from_io {
      color: #5881E8;
      margin-top: 20px;
      font-size: 20px;
      text-decoration:underline;
  }
  input.file {
      display: none;
  }
  .area-help {
      text-align: center;
      font-size: 24px;
      font-weight: 600;
      line-height: 40px;
  }
  @media (min-width: 768px) {
    .drop_area {
      width: 80%;
    }
  }
  .file_icon {
    -webkit-user-drag: none;
    -moz-user-select: none;
    user-select: none;
  }
</style>
